module.exports = __webpack_public_path__ + "img/stamp-golden-milestone-axe.893e4ebd.png";